import css from '../taskDescription.module.css'
import preview from './preview.png'
import taskDescriptionTexts from '../taskDescriptionTexts'

const ThirdTypeTaskDescription = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.image} style={{ backgroundImage: `url("${preview}")` }}>
        <div className={css.imageTaskTypeNumber}>
          <p style={{ fontSize: '24px', color: '#976153' }}>4</p>
        </div>
      </div>
      <p className={css.description}>{taskDescriptionTexts[3]}</p>
    </div>
  )
}

export default ThirdTypeTaskDescription
